/**
 * Tyl by Natwest pay-now form: submit-button processing state
 *
 * The plugin's own assets/js/custom-script.js disables the submit button
 * with `$form.find('input[type="submit"]').prop('disabled', true)` while
 * its AJAX request is in flight — but the actual control the template
 * renders is `<button type="submit" class="payup-button">`, not an
 * `input[type="submit"]`, so that call never matches anything and the
 * button is never really disabled. We can't edit the plugin, so instead
 * we watch for `.loading-indicator`, which the same code reliably
 * appends/removes around that request, and drive the real button's
 * disabled state from that.
 */
const TylPayNowForm = (() => {
	const init = () => {
		const form = document.querySelector('.tyl-pay-now__form form');
		if (!form) {
			return;
		}

		const button = form.querySelector('.payup-button');
		if (!button) {
			return;
		}

		const sync = () => {
			button.disabled = !!form.querySelector('.loading-indicator');
		};

		new MutationObserver(sync).observe(form, { childList: true });
	};

	return { init };
})();

export default TylPayNowForm;
